import React, {useEffect} from 'react';
import {
  useMsal,
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useIsAuthenticated,
} from '@azure/msal-react';
import {InteractionRequiredAuthError} from '@azure/msal-browser';
import {Button} from 'react-bootstrap';
import {useHistory} from 'react-router-dom';

const AzurePage = () => {
  const {instance, accounts} = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const history = useHistory();
  console.log('accounts', accounts);

  useEffect(() => {
    console.log('isAuthenticated', isAuthenticated);
    if (!isAuthenticated) {
      history.push('/login');
    }
  }, [isAuthenticated]);

  const handleLogout = () => {
    instance.logoutRedirect();
  };

  useEffect(() => {
    if (accounts.length) {
      //   const {username} = accounts[0];
      //   const username = 'dilshad@jadsau.onmicrosoft.com';

      // const currentAccount = instance.getAccountByLocalId(
      //   accounts[0].localAccountId
      // );

      const currentAccount = instance.getAccountByHomeId(
        accounts[0].homeAccountId
      );

      console.log('currentAccount', currentAccount);

      const silentRequest = {
        scopes: [
          'openid',
          'offline_access',
          // 'User.ReadWrite.All',
          // 'https://graph.microsoft.com/user.read.all',
          'ae717117-b5d3-4739-9214-d3bdaba7320c',

          // 'https://jadsau.onmicrosoft.com/ae717117-b5d3-4739-9214-d3bdaba7320c/User.ReadWrite.All',
        ],
        account: currentAccount,
        forceRefresh: false,
      };

      const request = {
        scopes: [
          'openid',
          'offline_access',
          'ae717117-b5d3-4739-9214-d3bdaba7320c',
          // 'https://graph.microsoft.com/User.Read.All',
          // 'Files.Read',
          // 'https://jadsau.onmicrosoft.com/ae717117-b5d3-4739-9214-d3bdaba7320c/Files.Read',
        ],
        loginHint: currentAccount.username, // For v1 endpoints, use upn from idToken claims
      };

      instance
        .acquireTokenSilent(silentRequest)
        .then((tokenResponse) => {
          console.log('tokenResponse', tokenResponse);
          return tokenResponse;
        })
        .catch((error) => {
          console.log('error', error);
          if (error instanceof InteractionRequiredAuthError) {
            // fallback to interaction when silent call fails
            return instance.acquireTokenRedirect(request);
          }
          return error;
        });
    } else {
      handleLogout();
    }
  }, [accounts]);

  return (
    <>
      <p>Anyone can see this paragraph.</p>
      <AuthenticatedTemplate>
        <p>
          At least one account is signed in!{' '}
          {accounts.length ? accounts[0].username : ''} ={' '}
          {accounts.length ? accounts[0].name : ''}
        </p>
        <Button onClick={handleLogout}>Logout</Button>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <p>No users are signed in!</p>
      </UnauthenticatedTemplate>
    </>
  );
};

export default AzurePage;
